<template>
    <div class="grid">
        <div class="col-12 lg:col-4">
            <div class="card flex flex-column">
                <div class="flex align-items-center flex-wrap mb-2">
                    <label class="text-base font-bold line-height-4 mr-4">{{ $t('lang.prolongation.tariff') }}</label>
                    <a :href="getDiffLink" target="_blank" class="text-primary text-xs">{{ $t('lang.prolongation.tariff_differences') }}</a>
                </div>
                <div class="formgrid">
                    <template v-if="promoTemplates">
                        <div v-for="tariff in promoTemplates" class="field-radiobutton">
                            <RadioButton
                                v-model="model.localTarif"
                                :inputId="getUID(tariff.id)"
                                name="tarif"
                                :value="tariff.id"
                                @change="clearSrok"
                                :disabled="isDisabled(tariff.id)"
                            />
                            <label :for="getUID(tariff.id)">{{ tariff.label }}</label>
                        </div>
                    </template>
                    <div v-for="tariff in tariffTemplates" class="field-radiobutton">
                        <RadioButton
                            v-model="model.localTarif"
                            :inputId="getUID(tariff.id)"
                            name="tarif"
                            :value="tariff.id"
                            @change="clearSrok"
                            :disabled="isDisabled(tariff.id)"
                        />
                        <label :for="getUID(tariff.id)">{{ tariff.label }}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 lg:col-8">
            <div class="mb-2">
                <label class="text-base font-bold line-height-4 mr-4">{{ $t('lang.login.change_date') }}</label>
            </div>
            <SubscriptionSrock :srok="model.localSrok" :tarif="model.localTarif" :balance-in-days="balanceInDays" :all-prices="allPrices" :tariffPercent="tariffPercent" :isPromo="isPromoTariff" v-on:update:srok="model.localSrok=$event"/>
        </div>
    </div>
</template>

<script>
import Badge from "primevue/badge";
import RadioButton from "primevue/radiobutton";
import Button from "primevue/button";
import uniqueId from "lodash/uniqueId";
import {TariffTime} from "../../page/tariff/constants/tariffTime";
import SubscriptionSrock from "./Srock.vue";

export default {
    name: "TariffSelector",
    props: {
        tariffTemplates: {
            type: Object,
            required: true,
            default: null,
        },
        promoTemplates: {
            type: Object,
            required: false,
            default: null,
        },
        tariffPercent: {
            type: Object,
            required: true,
            default: null,
        },
        tarif: {
            type: Number,
            required: false,
            default: null,
        },
        srok: {
            type: Number,
            required: false,
            default: null,
        },
        isDisabled: {
            type: Function,
            required: false,
            default: () => false,
        },
        allPrices: {
            type: Object,
            required: false
        },
        balanceInDays: {
            type: Number,
            required: false,
            default: null,
        },
        isFree: {
            type: Boolean,
            required: true
        }
    },
    emits: ['update:tarif', 'update:srok'],
    data() {
        return {
            uid: uniqueId('tariff-selector'),
            model: {
                localSrok: this.srok,
                localTarif: this.tarif,
            },
        };
    },
    computed: {
        TariffTime() {
            return TariffTime
        },
        isPromoTariff () {
            return false;
        },
        getDiffLink() {
            return sprintf('/%s/tarif', window.locale);
        }
    },
    methods: {
        getUID(slug) {
            return this.uid + '_' + slug;
        },
        clearSrok() {
            this.model.localSrok = TariffTime.ONE_MONTH_ID;
        },
    },
    watch: {
        model: {
            handler() {
                this.$emit('update:tarif', this.model.localTarif);
                this.$emit('update:srok', this.model.localSrok);
            },
            deep: true,
        }
    },
    components: {
        SubscriptionSrock,
        Badge,
        RadioButton,
        Button,
    },
}
</script>

<style scoped>
:deep(.p-badge) {
    margin-left: 0.625rem;
}
</style>
